import { registerEntityEndpoint as e } from "@editor/ui-utils";
var t = e("article-list"), { getEntity: n, listEntities: r, putEntity: i, postEntity: a, deleteEntity: o } = t, s = async (e, t = {}) => r({ params: {
	search: e,
	...t
} }), c = async (e) => n(e), l = (e) => {
	let { brand: t, ...n } = e;
	if (t === void 0) throw Error("an article list cannot be saved without a brand");
	return {
		...n,
		brand: t
	};
}, u = async (e) => a(e), d = async (e) => {
	let { _id: t, ...n } = e;
	return i(t, n);
}, f = async (e) => o(e), p = () => ({
	title: "",
	brand: void 0,
	articlesRef: [],
	isDeleted: !1,
	isAlternativeTeaserTitleShown: !1
});
//#endregion
export { s as a, d as c, c as i, l as n, p as o, f as r, u as s, t };

//# sourceMappingURL=article-list.service-DgVg00eV.js.map